import React from 'react';
import { useTranslation } from 'react-i18next';
import Benefit from '../Benefit';
import BenefitPlaceholder from '../BenefitPlaceholder';
import s from './Benefits.scss';
var Benefits = function (_a) {
    var benefits = _a.benefits, hasDiscord = _a.hasDiscord, showPlaceholder = _a.showPlaceholder;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        hasDiscord && (React.createElement(Benefit, { isDiscord: true, benefit: t('deviationview.tierCard.benefits.discord'), className: s['benefit'] })),
        benefits.map(function (benefit, index) { return (React.createElement(Benefit, { key: index, benefit: benefit, className: s['benefit'] })); }),
        showPlaceholder && benefits.length === 0 && React.createElement(BenefitPlaceholder, null)));
};
Benefits.displayName = 'Benefits';
export default Benefits;
//# sourceMappingURL=Benefits.js.map